import { CardHeader, Flex, Text } from '@chakra-ui/react'
import Flask from '../../../assets/svg/flask'
import { useTranslation } from 'react-i18next'

const Header = ({ updatedAt }: { updatedAt: moment.Moment }) => {
  const { t } = useTranslation()

  return (
    <CardHeader>
      <Flex direction={'row'} align={'center'} gap={2}>
        <Flask />
        <Text fontSize="xl">{t('ai.malaria.report.title')}</Text>
      </Flex>
      <Text fontSize="md" color={'brand.lightGrayText'}>
        {t('shared.common.updatedAt')} {`${updatedAt.format('DD.MM.YY HH:mm')}`}
      </Text>
    </CardHeader>
  )
}

export default Header
